import { shortenString } from "@lib/helpers/StringHelper";
import { Tag, Typography } from "antd";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { FaEnvelope, FaFingerprint, FaPhone } from "react-icons/fa";
import { AppListItemMetaProps } from "@lib/components/AppComponents/AppListNew";
import { booleanColor, userRoleColor } from "@lib/helpers/ColorHelper";
import { IoAccessibility } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";

export const SidebarManagerDetailListItems = ({ manager, isLoading }) => {
  const managerPhone = `${manager?.phoneCode || ""} ${manager?.phone || " - "}`;

  if (isLoading) return [];

  return [
    ...(manager?.provider
      ? [
          {
            avatar: <AiOutlineUser />,
            title: manager?.provider?.name,
          },
        ]
      : []),

    ...(manager?.customer
      ? [
          {
            avatar: <AiOutlineUser />,
            title: manager?.customer?.name,
          },
        ]
      : []),

    {
      avatar: <>ID</>,
      title: (
        <TableIdButton
          text={`#${shortenString(manager?.id, 20)}`}
          textToBeCopied={manager?.id}
        />
      ),
    },
    {
      avatar: <FaEnvelope />,
      title: (
        <Typography.Text ellipsis copyable={{ text: manager?.email }}>
          {manager?.email}
        </Typography.Text>
      ),
    },
    {
      avatar: <FaPhone />,
      title: <Typography.Text ellipsis>{managerPhone}</Typography.Text>,
    },
    {
      avatar: <IoAccessibility />,
      title: <Tag color={userRoleColor(manager?.role)}>{manager?.role}</Tag>,
    },
    {
      avatar: <FaFingerprint />,
      title: (
        <Tag color={booleanColor(manager?.isTwoFactorAuthEnabled)}>
          {manager?.isTwoFactorAuthEnabled ? "Enabled" : "Disabled"}
        </Tag>
      ),
    },
  ] as AppListItemMetaProps[];
};
